import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor() {}

  getFileNameFromUrl(url: string): string | null {
    try {
      // Step 1: Create a URL object to parse the URL
      // This will throw an error if the URL is invalid

      const urlObj = new URL(url);
      const pathname = urlObj.pathname; // e.g., /dermmedica/patients/document/116220/1750354727791.Screenshot 2025-06-18 230113.png

      // Step 2: Extract the filename from the pathname
      // This gets the last segment after the last '/'
      const lastSlashIndex = pathname.lastIndexOf('/');
      const filenameWithExtension = lastSlashIndex !== -1 ? pathname.substring(lastSlashIndex + 1) : pathname; // If no slash, the whole pathname is the filename
      return filenameWithExtension;
    } catch (error) {
      return null;
    }
  }
}
